import { Popper } from 'react-popper';
import OutsideClickHandler from 'components/OutsideClickHandler';
import { ContentWrapper } from './primitives';

const DesktopContentWrapper = ({ onClose, children }) => (
  <Popper placement="bottom-start">
    {({ ref, style }) => (
      <OutsideClickHandler onClickOutside={onClose}>
        <ContentWrapper mt={1} zIndex={1} ref={ref} style={style}>
          {children}
        </ContentWrapper>
      </OutsideClickHandler>
    )}
  </Popper>
);

export default DesktopContentWrapper;
